import React from 'react';
import Tooltip from '@amzn/meridian/tooltip';
import { ERROR_COLOR } from '@constants/values';
import infoTokens from '@amzn/meridian-tokens/base/icon/info';
import Icon from '@amzn/meridian/icon';
import { Action } from '@components/agile/types/AgileUploadRow';

export const AtRecommendedActionCellRenderer = (props: { value: Action }) => {
  const { value } = props;
  return (
    <>
      {value.note ? (
        <span style={{ marginRight: '8px' }}>
          <Tooltip position="end" title={value.note} data-testid="note-tooltip">
            <Icon tokens={infoTokens} className={ERROR_COLOR} data-testid="icon-component" />
          </Tooltip>
        </span>
      ) : null}
      {value.action as string}
    </>
  );
};

export default AtRecommendedActionCellRenderer;
